<template>
  <nav-bar-broker/>
</template>

<script>
import NavBarBroker from "@/components/broker/NavBarBroker.vue";

export default {
  name: "NavBarAdmin",
  components: {NavBarBroker},
};
</script>
